import $ from "jquery";
import GPXParser from "../apis/loadGpx";
import _ from 'lodash';
import React from "react";
import {getCurrentPoint} from "../util/player";
import {Link} from "react-router-dom";
import {Close} from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import {Sponsors} from "./Sponsors";
import {withWidth} from "@material-ui/core";
import Fab from "@material-ui/core/Fab";

const MapImplementation = (props) => {

    const addBounce = (marker) => {
        window.google.maps.event.addListener(marker, "mouseover", () => {
            if (marker.getAnimation() !== null) {
                marker.setAnimation(null);
            } else {
                marker.setAnimation(window.google.maps.Animation.BOUNCE);
            }
        });
        window.google.maps.event.addListener(marker, "mouseout",  () => {
            if (marker.getAnimation() !== null) {
                marker.setAnimation(null);
            } else {
                marker.setAnimation(window.google.maps.Animation.BOUNCE);
            }
        });
    }

    const addCheckpoint = (lat,long,myMap,myIcon,myAnimation) =>{
        const mark = new window.google.maps.Marker({
            position: new window.google.maps.LatLng(lat,long),
            map: myMap,
            animation: myAnimation,
            icon: myIcon
        });
        window.google.maps.event.addListener(mark, 'click', function() {
            myMap.panTo(mark.getPosition());
        });
        return mark
    }

    const addInfoWindow = (html,myMap,marker) => {
        let infoWindow = new window.google.maps.InfoWindow({
            content: html,
            size: new window.google.maps.Size(50, 50)
        });
        window.google.maps.event.addListener(marker, "click", () => {
            infoWindow.open(myMap, marker);
        });
        return infoWindow;
    }

    const drawAllCheckpoints = (checkpoints,myMap,checks) => {
        let result = []
        checkpoints.forEach((currentCheckpoint)=>{
            //if(checks.findIndex((checks)=>checks.name===currentCheckpoint.name)<0) {
                result.push(addCheckpoint(currentCheckpoint.lat,
                    currentCheckpoint.long,
                    myMap,
                    require("../assets/checkpoint.png"),
                    window.google.maps.Animation.DROP))
            //}
        })

        return result
    }

    const getCheckpointDetails = (checkpoint,checkpoints) => {
        if(checkpoint==='p1'){
            return checkpoints[0]
        }
        return checkpoints.find((cp)=>{return cp.name===checkpoint})
    }

    const showMap = (raceName) => {
        const mapOptions = {
            minZoom:9,
            zoom: 9,
            tilt:45,
            gestureHandling:'greedy',
            mapTypeId: "hybrid",
            disableDefaultUI:true,
            disableDoubleClickZoom:true,
        };
        let googleMap = new window.google.maps.Map(props.myRef.current,mapOptions)
        const harta1= require(`../assets/${raceName}.gpx`);
        loadGPXFileIntoGoogleMap(googleMap,harta1)
        return googleMap
    }

    const loadGPXFileIntoGoogleMap = (map, filename) => {
        $.ajax(
            {context:this,
                url: filename,
                dataType: "xml",
                success: (data) => {
                    var parser = new GPXParser(data, map);
                    parser.setTrackColour("#1ea913");     // Set the track line colour
                    parser.setTrackWidth(5);          // Set the track line width
                    parser.setMinTrackPointDelta(0.001);      // Set the minimum distance between track points
                    parser.centerAndZoom(data);
                    parser.addTrackpointsToMap();         // Add the trackpoints
                    parser.addRoutepointsToMap();         // Add the routepoints
                    parser.addWaypointsToMap();           // Add the waypoints
                }
            });
    }

    const addInfoWindows = (mapCheckpoints,checkpoints,myMap) => {
        let infoWindows = []
        for (let i = 0; i < mapCheckpoints.length; i++) {
            const playerTimes = props.players.reduce((result, player) => {
                return result+player.name + " : " + player[checkpoints[i].name] + "<br>"
            },[]);
            const html = "<div >" + playerTimes + checkpoints[i].description + "<br>" +
                "Altitudine: " + checkpoints[i].altitude +
                "<br> Câștig de altitudine: " + checkpoints[i].elevation_gain + "<br> " +
                "Pierdere de altitudine: " + checkpoints[i].elevation_lost + "<br>" +
                ""
                + "</div>"
            infoWindows.push({info:addInfoWindow(html, myMap, mapCheckpoints[i]),marker:mapCheckpoints[i]});
        }
        return infoWindows
    }

    const addPlayerWindows = (players,mapPlayers,checkpoints,myMap) => {
        let infoWindows = []
        for (let i = 0; i < mapPlayers.length; i++) {
            const currentCheckpoint = getCurrentPoint(players[i]);
            const currentCheckDetail = getCheckpointDetails(currentCheckpoint,checkpoints)
            const playerTimes = players[i].name +
                "<br>Locul : " + players[i].position +
                "<br>Ultimul Checkpoint : " + currentCheckDetail.description;
            const html = "<div >" + playerTimes + " " +  players[i][currentCheckpoint] + "<br>" +
                "Altitudine: " + currentCheckDetail.altitude +
                "<br> Câștig de altitudine: " + currentCheckDetail.elevation_gain + "<br> " +
                "Pierdere de altitudine: " + currentCheckDetail.elevation_lost + "<br>" +
                ""
                + "</div>"
            infoWindows.push(addInfoWindow(html, myMap, mapPlayers[i]));
        }
        return infoWindows
    }

    if(!_.isEmpty(props.race)) {
        const checkpoints = props.race.checkpoints;
        const myMap = showMap(props.race.name)
        const playerCheckpoints = props.players.map((player) => {
            return getCheckpointDetails(getCurrentPoint(player), checkpoints);
        })
        const mapCheckpoints = drawAllCheckpoints(checkpoints, myMap, playerCheckpoints)
        const mapPlayers = props.players.map((player,index) => {
            let currentCheckpoint = getCurrentPoint(player);
            if(currentCheckpoint!==undefined) {
                currentCheckpoint = getCheckpointDetails(currentCheckpoint, checkpoints);
                const offsetY = ((Math.random() - 0.5) / 40) - index * 0.001
                const offsetX = ((Math.random() - 0.5) / 40) - index * 0.001
                currentCheckpoint.lat = currentCheckpoint.lat + offsetY
                currentCheckpoint.long = currentCheckpoint.long + offsetX
                const mapPlayer = addCheckpoint(currentCheckpoint.lat, currentCheckpoint.long, myMap, require(`../assets/runner${index}.png`), window.google.maps.Animation.BOUNCE)
                addBounce(mapPlayer)
                return mapPlayer
            }
            return null
        });

        const infoWindows = addInfoWindows(mapCheckpoints,checkpoints,myMap)

        infoWindows.forEach((win,index1) => {
            const {marker, info} = win
            window.google.maps.event.addListener(marker, "click", () => {
                infoWindows.forEach((win2,index2) => {
                    if(index1!==index2)win2.info.close(myMap, marker)
                })
            })
        })


        const playerWindows = addPlayerWindows(props.players,mapPlayers,checkpoints,myMap)

        window.google.maps.event.addListener(myMap, "click", function (event) {
            for (let i = 0; i < playerWindows.length; i++) {
                playerWindows[i].close();
            }
        });
        window.google.maps.event.addListener(myMap, "click", function (event) {
            for (let i = 0; i < infoWindows.length; i++) {
                infoWindows[i].info.close();
            }
        });

    }
    const renderLegend = () => {
        return props.players.map((player,index) => {
            return(<Fab key={index} size={"small"} variant={"extended"} style={{margin:'10px'}}>
                #{player.position}<img src={require(`../assets/runner${index}.png`)} alt={"playerIcon"}/> {player.name}
            </Fab>)
        })

    }

    const sponsorSize = (props.width==='xs' || props.width ==="sm") ? '32px': '55px'

    return (<div>
        <div style={{position:'absolute',top:'5px', left:'5px'}}> {renderLegend()} </div>
        <div style={{position:'absolute',top:'5px',right:'5px'}}>
            <Fab size={"small"} onClick={props.handleClose}><Close fontSize={"small"}/></Fab></div>
        <div style={{position:'absolute',bottom:'20px',left:'10px'}}><Sponsors size={sponsorSize}/></div>
    </div>);
}
    export default withWidth()(MapImplementation);

